import { LocalStorageKey } from '@/lib/storageConstants'
import { redirectToLogin } from '@/modules/auth/returnPath'
import {
    applySharedProductDataToLinks,
    FontSlot,
} from '@storefronts/common-types'
import {
    AdPlatform,
    AdminClientOnboarding,
    AdminClientSettings,
    AdminCrowLink,
    AdminSellingPlanGroup,
    AdminShopifyProduct,
    ApiCrowLink,
    ApiResponse,
    BulkUpdateBrandBenefitsRequest,
    ClientOnboardingResponse,
    CreateBrandGuidelineResponse,
    CreateCollectionResponse,
    CreateCrowLinkRequest,
    CreateCrowLinkResponse,
    CreateExperimentGroupRequest,
    CreateExperimentGroupResponse,
    CreateManyCrowLinksRequest,
    CreateManyCrowLinksResponse,
    CreateLandingPageRequestBody,
    CreateLandingPageResponse,
    CreateLandingPageTemplateRequestBody,
    CreateLandingPageTemplateResponse,
    CreatePlaylistResponse,
    CreateVideoInput,
    CreateVideoResponse,
    DeleteBrandGuidelineResponse,
    DeleteCollectionResponse,
    DeleteLandingPageTemplateResponse,
    DeleteVideoResponse,
    DuplicateLandingPageRequestBody,
    DuplicateLandingPageResponse,
    ExperimentDetailsResponse,
    ExperimentMetricsResponse,
    ExperimentsListResponse,
    ExperimentType,
    ExploCustomerTokenResponse,
    ExploDashboardType,
    FullFunnelAggregationsResponse,
    FunnelOverviewResponse,
    FunnelReportResponse,
    GetAllCollectionsResponse,
    GetAllCrowLinksResponse,
    GetAllImagesResponse,
    GetAllLandingPageLinksResponse,
    GetPaginatedLandingPageLinksRequest,
    GetPaginatedLandingPageLinksResponse,
    GetAllLandingPagesResponse,
    GetAllLandingPageTemplateResponse,
    GetAllPlaylistsResponse,
    GetAllProductsOrderedByRelevanceToMetaAdRequest,
    GetAllProductsOrderedByRelevanceToMetaAdResponse,
    GetAllStorefrontGeneratorLandingPagesRequest,
    GetAllStorefrontGeneratorLandingPagesResponse,
    GetAllUsersResponse,
    GetAllVideosResponse,
    GetAuthenticatedSignatureResponse,
    GetAuthenticatedUploadURLResponse,
    GetAvailableClientsResponse,
    GetBrandBenefitsResponse,
    GetClientAllShopifyCollectionsRequest,
    GetClientAllShopifyCollectionsResponse,
    GetClientAllShopifyProductsRequest,
    GetClientAllShopifyProductsResponse,
    GetClientResponse,
    GetClientSettingsResponse,
    GetTypographyRoleOverridesResponse,
    UpsertTypographyRoleOverridesRequest,
    UpsertTypographyRoleOverridesResponse,
    GetCustomFontFamiliesResponse,
    GetClientUnimportedShopifyProductsRequest,
    TrackingPixelData,
    UpdateTrackingPixelsResponse,
    GetClientUnimportedShopifyProductsResponse,
    GetCollectionResponse,
    GetCrowLinkResponse,
    GetCrowLinksByLandingPageResponse,
    GetDynamicGridProductsBatchRequestBody,
    GetCollectionsForProductResponse,
    GetDynamicGridProductsBatchResponse,
    GetLandingPageLinkResponse,
    GetLandingPageLinksBatchRequestBody,
    GetLandingPageLinksBatchResponseBody,
    GetLandingPagePlaylistResponse,
    GetLandingPageResponse,
    GetLandingPageOrderLineItemSummaryResponse,
    GetLandingPageSourceAdResponse,
    GetPlaylistResponse,
    GetProfileResponse,
    GetTemplatesRankedInput,
    GetTemplatesRankedResponse,
    GetVideoResponse,
    ImportShopifyCollectionResponse,
    ImportWebsiteFontsResponse,
    ImportShopifyProductResponse,
    BatchImportTopProductsResponse,
    LiveExperimentsResponse,
    LoginResponse,
    MetaAd,
    MetaAdResponse,
    Persona,
    ResyncimagesForLandingPageLinkRequestBody,
    ResyncimagesForLandingPageLinkResponse,
    QueueReviewAnalysisForAllClientLinksResponse,
    QueueReviewAnalysisForLandingPageLinkResponse,
    TriggerDiscountSyncResponse,
    GetDiscountSyncStatusResponse,
    RegenerateAllPDPsRequestBody,
    RegenerateAllPDPsResponse,
    RegeneratePDPForLandingPageLinkRequestBody,
    RegeneratePDPForLandingPageLinkResponse,
    AI_CREATE_SESSION_SOURCE,
    AICreatePreselections,
    CreateAICreateSessionRequestBody,
    CreateAICreateSessionResponse,
    CreateAICreateSessionRunResponse,
    CreateEditChatSessionResponse,
    GetEditChatAttachmentUploadSignatureResponse,
    GetEditChatSessionResponse,
    CancelEditChatTurnResponse,
    PostEditChatMessageRequestBody,
    PostEditChatMessageResponse,
    GetStorefrontAiFeedbackEligibilityResponse,
    PostCropFitRequestBody,
    PostCropFitResponse,
    PostStorefrontAiFeedbackRequestBody,
    PostStorefrontAiFeedbackResponse,
    UndoBrandGuidelineResponse,
    SearchGoogleFontsResponse,
    UploadCustomFontFilesResponse,
    UpdateCustomFontFamilyResponse,
    SlackChannelWithShareLink,
    StorefrontMetricsResponse,
    TopPerformingCreativesResponse,
    UpdateBrandGuidelineResponse,
    UpdateClientInput,
    UpdateClientResponse,
    UpdateCollectionInput,
    UpdateCollectionResponse,
    UpdateCrowLinkRequest,
    UpdateCrowLinkResponse,
    UpdateExperimentDetailsRequest,
    SaveLandingPagePayload,
    SaveLandingPageResponse,
    CreatePlacementOptionRuleRequestBody,
    DeleteAllPlacementOptionRulesForLinkResponse,
    GetPlacementOptionRulesForLinkResponse,
    ListPlacementOptionRulesResponse,
    PlacementOptionRule,
    UpdatePlacementOptionRuleRequestBody,
    AssignStorefrontTagRequestBody,
    AssignStorefrontTagResponse,
    CreateStorefrontTagRequestBody,
    CreateStorefrontTagResponse,
    DeleteStorefrontTagResponse,
    GetStorefrontTagsResponse,
    RenameStorefrontTagRequestBody,
    RenameStorefrontTagResponse,
    CreateGiftPromotionRequestBody,
    CreateGiftPromotionResponse,
    DeleteGiftPromotionResponse,
    GetGiftPromotionsResponse,
    UpdateGiftPromotionRequestBody,
    UpdateGiftPromotionResponse,
    UpdateLandingPageCartUpsellsBody,
    UpdateLandingPageCartUpsellsResponse,
    UpdateLandingPageContentRequestBody,
    UpdateLandingPageContentResponse,
    UpdateLandingPageLinkContentRequest,
    UpdateLandingPageLinkContentResponse,
    UpdateLandingPageLinkRequestBody,
    UpdateLandingPageLinkResponse,
    UpdateLandingPageLinksBody,
    UpdateLandingPageLinksResponse,
    UpdateLandingPageRequestBody,
    UpdateLandingPageResponse,
    UpdateLandingPageTemplateRequestBody,
    UpdateLandingPageTemplateResponse,
    UpdatePlaylistRequestBody,
    UpdatePlaylistResponse,
    UpdateReviewPlatformInput,
    UpdateVideoInput,
    UpdateVideoResponse,
    UploadImageResponse,
    UploadImagesResponse,
    UploadLocalImageInput,
    GetPromotionsResponse,
    BulkUpsertPromotionsRequest,
    ScheduledPromotionResponse,
    UpsertScheduledPromotionRequest,
    CreateS3UploadUrlResponse,
    PDPRegenerationStatusResponse,
    CreateVirtualProductRequest,
    CreateVirtualProductResponse,
    UpdateVirtualProductRequest,
    UpdateVirtualProductResponse,
    GetAllVirtualProductsResponse,
    GetVirtualProductResponse,
    DuplicateVirtualProductResponse,
    ChangeParentVirtualProductResponse,
    GetVirtualProductUsageResponse,
    DeleteVirtualProductResponse,
    SubstituteVirtualProductInStorefrontsResponse,
    BulkReplaceNonVirtualResponse,
    GetRelatedProductsResponse,
    QueueVirtualProductSetupResponse,
    DiscoverProductFamiliesRequest,
    DiscoverProductFamiliesResponse,
    ListProductFamiliesResponse,
    PersistProductFamiliesRequest,
    PersistProductFamiliesResponse,
    SetProductFamilyActiveRequest,
    SetProductFamilyActiveResponse,
    CreatePromptLabRunRequestBody,
    CreatePromptLabRunResponse,
    GetPromptLabPairsResponse,
    CreateBrandCategoryRequestBody,
    CreateBrandCategoryResponse,
    CreateLayoutFormatRequestBody,
    CreateLayoutFormatResponse,
    CreateLayoutReferenceRequestBody,
    CreateLayoutReferenceResponse,
    DeleteBrandCategoryResponse,
    DeleteLayoutFormatResponse,
    DeleteLayoutReferenceResponse,
    GetAllBrandCategoriesResponse,
    GetAllLayoutFormatsResponse,
    GetAllLayoutReferencesResponse,
    UpdateBrandCategoryRequestBody,
    UpdateBrandCategoryResponse,
    UpdateLayoutFormatRequestBody,
    UpdateLayoutFormatResponse,
    UpdateLayoutReferenceRequestBody,
    UpdateLayoutReferenceResponse,
    GetStorefrontReviewScoreTrendResponse,
    AdminDiscountCodeLookup,
    CreateSupportTicketRequest,
    CreateSupportTicketResponse,
    GetJudgeCalibrationNextResponse,
    PostJudgeCalibrationScoreRequestBody,
    PostJudgeCalibrationScoreResponse,
} from '@storefronts/common-types'
import queryString from 'query-string'
import config from '../../config'
import { API } from './routes'

class Requestor {
    private static instance: Requestor

    client: string | null = null

    private constructor() {}

    public static getInstance(): Requestor {
        if (!Requestor.instance) {
            Requestor.instance = new Requestor()
        }
        return Requestor.instance
    }

    setClient(client: string) {
        this.client = client
    }

    getBearerToken(): string {
        const jwt = window.localStorage.getItem(LocalStorageKey.JWT)
        if (!jwt) {
            redirectToLogin()
        }
        return `Bearer ${jwt}`
    }

    checkResponseAuth(response: Response): void {
        if (response.status == 401) {
            redirectToLogin()
        }
    }

    get apiBaseUrl(): string {
        return `${config('API_BASEURL')}/api/client/${this.client}`
    }

    async makeAuthenticatedRequest<K>(
        path: string,
        queryParams: Record<string, unknown> | null = null,
        opts: RequestInit = {},
        pathOverride: boolean = false,
    ): Promise<K> {
        let headers: HeadersInit = opts.headers || {}

        headers = {
            Authorization: this.getBearerToken(),
            ...headers,
        }

        // Build query string only for GET requests
        let qs = ''
        if (queryParams && opts.method?.toLowerCase() === 'get') {
            qs = queryString.stringify(queryParams, { arrayFormat: 'bracket' })
        }

        let fullPath = `api/client/${this.client}/${path}${qs ? `?${qs}` : ''}`
        if (pathOverride) {
            fullPath = path
        }

        const url = `${config('API_BASEURL')}/${fullPath}`

        // Handle request body for methods that send a JSON body
        if (
            opts.method === 'post' ||
            opts.method === 'put' ||
            opts.method === 'patch' ||
            opts.method === 'delete'
        ) {
            opts.body = JSON.stringify(queryParams)
        }

        const resp = await fetch(url, {
            ...opts,
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
        })

        const response = await resp.json()

        this.checkResponseAuth(resp)

        if (!resp.ok && response && response.isError === undefined) {
            return {
                isError: true,
                name: response.error ?? 'Error',
                message: Array.isArray(response.message)
                    ? response.message.join(', ')
                    : (response.message ?? 'Request failed'),
            } as K
        }

        return response as K
    }

    async loginEmailPassword(
        email: string,
        password: string,
    ): Promise<LoginResponse> {
        const resp = await fetch(
            `${config('API_BASEURL')}/auth/login-email-pwd`,
            {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    username: email,
                    password,
                }),
            },
        )

        const response = await resp.json()

        if (response.statusCode == 401) {
            return {
                success: false,
                accessToken: null,
            }
        }

        if (response.isError) {
            throw new Error(response.message)
        }

        return {
            success: true,
            accessToken: response.result.accessToken,
        }
    }

    async logout(): Promise<{ success: boolean; message: string }> {
        const jwt = window.localStorage.getItem(LocalStorageKey.JWT)

        if (!jwt) {
            // Already logged out
            return {
                success: true,
                message: 'Already logged out',
            }
        }

        try {
            const resp = await fetch(`${config('API_BASEURL')}/auth/logout`, {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwt}`,
                },
            })

            const response = await resp.json()

            if (response.isError) {
                // Even if server logout fails, clear local storage
                window.localStorage.removeItem(LocalStorageKey.JWT)
                return {
                    success: false,
                    message: response.message || 'Logout failed',
                }
            }

            // Clear local storage after successful server logout
            window.localStorage.removeItem(LocalStorageKey.JWT)

            return {
                success: true,
                message: response.result?.message || 'Logout successful',
            }
        } catch (_error) {
            // If network error, still clear local storage
            window.localStorage.removeItem(LocalStorageKey.JWT)
            return {
                success: false,
                message: 'Network error during logout',
            }
        }
    }

    async getProfile(): Promise<GetProfileResponse> {
        const jwt = window.localStorage.getItem(LocalStorageKey.JWT)

        if (!jwt) {
            redirectToLogin()
        }

        const headers = {
            Authorization: `Bearer ${jwt}`,
            'Content-Type': 'application/json',
        }

        const resp = await fetch(
            `${config('API_BASEURL')}/${API.GetProfile()}`,
            {
                method: 'post',
                headers,
                body: JSON.stringify({}),
            },
        )

        const response = await resp.json()

        if (response.statusCode == 401) {
            return {
                isAuthenticated: false,
                user: null,
            }
        }

        if (response.isError) {
            throw new Error(response.message)
        }

        const res = response.result as GetProfileResponse

        if (!res.isAuthenticated) {
            return res
        }

        if (res.user.client) {
            this.setClient(res.user.client.clientHash)
        }
        return res
    }

    async createPromptLabRun(
        body: CreatePromptLabRunRequestBody,
    ): Promise<CreatePromptLabRunResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<CreatePromptLabRunResponse>
        >(API.CreatePromptLabRun(), body, { method: 'post' }, true)

        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async getPromptLabPairs(): Promise<GetPromptLabPairsResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetPromptLabPairsResponse>
        >(API.GetPromptLabPairs(), {}, { method: 'get' }, true)

        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async getAllLayoutReferences(): Promise<GetAllLayoutReferencesResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetAllLayoutReferencesResponse>
        >(API.GetAllLayoutReferences(), {}, { method: 'get' }, true)

        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async createLayoutReference(
        body: CreateLayoutReferenceRequestBody,
    ): Promise<CreateLayoutReferenceResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<CreateLayoutReferenceResponse>
        >(API.CreateLayoutReference(), body, { method: 'post' }, true)

        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async updateLayoutReference(
        id: number,
        body: UpdateLayoutReferenceRequestBody,
    ): Promise<UpdateLayoutReferenceResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<UpdateLayoutReferenceResponse>
        >(API.UpdateLayoutReference(id), body, { method: 'put' }, true)

        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async deleteLayoutReference(
        id: number,
    ): Promise<DeleteLayoutReferenceResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<DeleteLayoutReferenceResponse>
        >(API.DeleteLayoutReference(id), {}, { method: 'delete' }, true)

        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async getAllLayoutFormats(): Promise<GetAllLayoutFormatsResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetAllLayoutFormatsResponse>
        >(API.GetAllLayoutFormats(), {}, { method: 'get' }, true)

        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async createLayoutFormat(
        body: CreateLayoutFormatRequestBody,
    ): Promise<CreateLayoutFormatResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<CreateLayoutFormatResponse>
        >(API.CreateLayoutFormat(), body, { method: 'post' }, true)

        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async updateLayoutFormat(
        id: number,
        body: UpdateLayoutFormatRequestBody,
    ): Promise<UpdateLayoutFormatResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<UpdateLayoutFormatResponse>
        >(API.UpdateLayoutFormat(id), body, { method: 'put' }, true)

        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async deleteLayoutFormat(id: number): Promise<DeleteLayoutFormatResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<DeleteLayoutFormatResponse>
        >(API.DeleteLayoutFormat(id), {}, { method: 'delete' }, true)

        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async getAllBrandCategories(): Promise<GetAllBrandCategoriesResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetAllBrandCategoriesResponse>
        >(API.GetAllBrandCategories(), {}, { method: 'get' }, true)

        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async createBrandCategory(
        body: CreateBrandCategoryRequestBody,
    ): Promise<CreateBrandCategoryResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<CreateBrandCategoryResponse>
        >(API.CreateBrandCategory(), body, { method: 'post' }, true)

        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async updateBrandCategory(
        id: number,
        body: UpdateBrandCategoryRequestBody,
    ): Promise<UpdateBrandCategoryResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<UpdateBrandCategoryResponse>
        >(API.UpdateBrandCategory(id), body, { method: 'put' }, true)

        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async deleteBrandCategory(
        id: number,
    ): Promise<DeleteBrandCategoryResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<DeleteBrandCategoryResponse>
        >(API.DeleteBrandCategory(id), {}, { method: 'delete' }, true)

        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async getStorefrontReviewScoreTrend(
        days: number,
    ): Promise<GetStorefrontReviewScoreTrendResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetStorefrontReviewScoreTrendResponse>
        >(API.GetStorefrontReviewScoreTrend(days), {}, { method: 'get' }, true)

        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async getJudgeCalibrationNext(
        skip: number,
    ): Promise<GetJudgeCalibrationNextResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetJudgeCalibrationNextResponse>
        >(API.GetJudgeCalibrationNext(skip), {}, { method: 'get' }, true)

        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async submitJudgeCalibrationScore(
        body: PostJudgeCalibrationScoreRequestBody,
    ): Promise<PostJudgeCalibrationScoreResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<PostJudgeCalibrationScoreResponse>
        >(API.PostJudgeCalibrationScore(), body, { method: 'post' }, true)

        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async getAllVideos(): Promise<GetAllVideosResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetAllVideosResponse>
        >(API.GetAllVideos(), {}, { method: 'get' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async getAuthenticatedUploadURL(
        videoHash: string,
    ): Promise<GetAuthenticatedUploadURLResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetAuthenticatedUploadURLResponse>
        >(
            API.GetAuthenticatedUploadURL(),
            {
                videoHash,
            },
            { method: 'post' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async createVideo(
        videoData: CreateVideoInput,
    ): Promise<CreateVideoResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<CreateVideoResponse>
        >(
            API.CreateVideo(),
            {
                ...videoData,
            },
            { method: 'post' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getVideo(videoHash: string): Promise<GetVideoResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetVideoResponse>
        >(API.GetVideo(videoHash), {}, { method: 'get' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async updateVideo(
        videoHash: string,
        videoData: UpdateVideoInput,
    ): Promise<UpdateVideoResponse> {
        console.log(videoData)
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<UpdateVideoResponse>
        >(
            API.UpdateVideo(videoHash),
            {
                ...videoData,
            },
            { method: 'post' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async deleteVideo(videoHash: string): Promise<DeleteVideoResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<DeleteVideoResponse>
        >(API.DeleteVideo(videoHash), {}, { method: 'delete' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getAllPlaylists(): Promise<GetAllPlaylistsResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetAllPlaylistsResponse>
        >(API.GetAllPlaylists(), {}, { method: 'get' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getPlaylist(playlistHash: string): Promise<GetPlaylistResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetPlaylistResponse>
        >(API.GetPlaylist(playlistHash), {}, { method: 'get' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getLandingPagePlaylist(
        playlistHash: string,
    ): Promise<GetLandingPagePlaylistResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetLandingPagePlaylistResponse>
        >(API.GetLandingPagePlaylist(playlistHash), {}, { method: 'get' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async createPlaylist(
        videoHashes: string[],
        name: string,
        thumbnailUrl?: string,
        bannerText?: string,
        isHidden?: boolean,
    ): Promise<CreatePlaylistResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<CreatePlaylistResponse>
        >(
            API.CreatePlaylist(),
            {
                videoHashes,
                name,
                thumbnailUrl,
                bannerText,
                isHidden,
            },
            { method: 'post' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async updatePlaylist(
        playlistHash: string,
        playlistData: UpdatePlaylistRequestBody,
    ): Promise<UpdatePlaylistResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<UpdatePlaylistResponse>
        >(
            API.UpdatePlaylist(playlistHash),
            {
                ...playlistData,
            },
            { method: 'post' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getAuthenticatedSignature(): Promise<GetAuthenticatedSignatureResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetAuthenticatedSignatureResponse>
        >(API.GetAuthenticatedUploadSignature(), {}, { method: 'get' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getClient(): Promise<GetClientResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetClientResponse>
        >(API.GetClient(), {}, { method: 'get' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async updateClient(
        clientData: UpdateClientInput,
    ): Promise<UpdateClientResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<UpdateClientResponse>
        >(
            API.UpdateClient(),
            {
                ...clientData,
            },
            { method: 'post' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async updateClientReviewPlatform(
        body: UpdateReviewPlatformInput,
    ): Promise<GetClientResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetClientResponse>
        >(
            API.UpdateClientReviewPlatform(),
            {
                ...body,
            },
            { method: 'post' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async updateTrackingPixels(
        trackingPixels: Partial<TrackingPixelData>,
    ): Promise<UpdateTrackingPixelsResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<UpdateTrackingPixelsResponse>
        >(API.UpdateTrackingPixels(), trackingPixels, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getAllUsers(): Promise<GetAllUsersResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetAllUsersResponse>
        >(API.GetAllUsers(), {}, { method: 'get' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async getAllCollections(): Promise<GetAllCollectionsResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetAllCollectionsResponse>
        >(API.GetAllCollections(), {}, { method: 'get' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getCollection(
        collectionHash: string,
    ): Promise<GetCollectionResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetCollectionResponse>
        >(API.GetCollection(collectionHash), {}, { method: 'get' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async createCollection(
        playlistHashes: string[],
        name: string,
        newOrderOfPlaylistHashes: string[],
        collectionBarColor?: string,
        playlistCircleBorderColor?: string,
        fontColor?: string,
    ): Promise<CreateCollectionResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<CreateCollectionResponse>
        >(
            API.CreateCollection(),
            {
                playlistHashes,
                name,
                newOrderOfPlaylistHashes,
                collectionBarColor,
                playlistCircleBorderColor,
                fontColor,
            },
            { method: 'post' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async discoverProductFamilies(
        body: DiscoverProductFamiliesRequest,
    ): Promise<DiscoverProductFamiliesResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<DiscoverProductFamiliesResponse>
        >(API.DiscoverProductFamilies(), body, { method: 'post' })
        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async persistProductFamilies(
        body: PersistProductFamiliesRequest,
    ): Promise<PersistProductFamiliesResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<PersistProductFamiliesResponse>
        >(API.PersistProductFamilies(), body, { method: 'post' })
        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async listProductFamilies(): Promise<ListProductFamiliesResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<ListProductFamiliesResponse>
        >(API.ListProductFamilies(), {}, { method: 'get' })
        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async setProductFamilyActive(
        body: SetProductFamilyActiveRequest,
    ): Promise<SetProductFamilyActiveResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<SetProductFamilyActiveResponse>
        >(API.SetProductFamilyActive(), body, { method: 'post' })
        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async createVirtualProduct(
        body: CreateVirtualProductRequest,
    ): Promise<CreateVirtualProductResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<CreateVirtualProductResponse>
        >(API.CreateVirtualProduct(), body, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getAllVirtualProducts(
        replaceNonVirtualProductsFilter: boolean = true,
    ): Promise<GetAllVirtualProductsResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetAllVirtualProductsResponse>
        >(
            API.GetAllVirtualProducts(),
            { replaceNonVirtualProductsFilter },
            { method: 'get' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async duplicateVirtualProduct(
        id: number,
    ): Promise<DuplicateVirtualProductResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<DuplicateVirtualProductResponse>
        >(API.DuplicateVirtualProduct(id), {}, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async changeParentVirtualProduct(
        id: number,
    ): Promise<ChangeParentVirtualProductResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<ChangeParentVirtualProductResponse>
        >(API.ChangeParentVirtualProduct(id), {}, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getVirtualProductUsage(
        id: number,
        mode: 'delete' | 'substitute',
    ): Promise<GetVirtualProductUsageResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetVirtualProductUsageResponse>
        >(API.GetVirtualProductUsage(id), { mode }, { method: 'get' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async deleteVirtualProduct(
        id: number,
    ): Promise<DeleteVirtualProductResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<DeleteVirtualProductResponse>
        >(API.DeleteVirtualProduct(id), {}, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async substituteVirtualProductInStorefronts(
        id: number,
    ): Promise<SubstituteVirtualProductInStorefrontsResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<SubstituteVirtualProductInStorefrontsResponse>
        >(API.SubstituteVirtualProductInStorefronts(id), {}, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getVirtualProduct(id: number): Promise<GetVirtualProductResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetVirtualProductResponse>
        >(API.GetVirtualProduct(id), {}, { method: 'get' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async updateVirtualProduct(
        id: number,
        body: UpdateVirtualProductRequest,
    ): Promise<UpdateVirtualProductResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<UpdateVirtualProductResponse>
        >(API.UpdateVirtualProduct(id), body, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async bulkReplaceNonVirtual(
        replaceNonVirtualProducts: boolean,
        parentId?: number,
    ): Promise<BulkReplaceNonVirtualResponse> {
        const body: {
            replaceNonVirtualProducts: boolean
            parentId?: number
        } = { replaceNonVirtualProducts }
        if (parentId != null) {
            body.parentId = parentId
        }
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<BulkReplaceNonVirtualResponse>
        >(API.BulkReplaceNonVirtual(), body, { method: 'post' })
        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async getRelatedProducts(
        productIds: string[],
    ): Promise<GetRelatedProductsResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetRelatedProductsResponse>
        >(
            API.GetRelatedProducts() + `?productIds=${productIds.join(',')}`,
            {},
            { method: 'get' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getAllProductOptions(): Promise<
        Array<{
            id: number
            optionKey: string
            optionValue: string
            swatchColor: string | null
            swatchImage: string | null
            createdAt: Date
            updatedAt: Date
            shopifyProductIds: string[]
        }>
    > {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<
                Array<{
                    id: number
                    optionKey: string
                    optionValue: string
                    swatchColor: string | null
                    swatchImage: string | null
                    createdAt: Date
                    updatedAt: Date
                    shopifyProductIds: string[]
                }>
            >
        >(API.GetAllProductOptions(), {}, { method: 'get' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async createProductOption(body: {
        optionKey: string
        optionValue: string
        swatchColor?: string | null
        swatchImage?: string | null
        shopifyProductIds?: string[]
    }): Promise<{
        id: number
        optionKey: string
        optionValue: string
        swatchColor: string | null
        swatchImage: string | null
    }> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<{
                id: number
                optionKey: string
                optionValue: string
                swatchColor: string | null
                swatchImage: string | null
            }>
        >(API.CreateProductOption(), body, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async updateProductOption(
        id: number,
        body: {
            optionKey?: string
            optionValue?: string
            swatchColor?: string | null
            swatchImage?: string | null
            shopifyProductIds?: string[]
        },
    ): Promise<{
        id: number
        optionKey: string
        optionValue: string
        swatchColor: string | null
        swatchImage: string | null
    }> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<{
                id: number
                optionKey: string
                optionValue: string
                swatchColor: string | null
                swatchImage: string | null
            }>
        >(API.UpdateProductOption(id), body, { method: 'put' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async deleteProductOption(id: number): Promise<{ success: boolean }> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<{ success: boolean }>
        >(API.DeleteProductOption(id), {}, { method: 'delete' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async triggerOptionExtraction(body: { productId?: string }): Promise<{
        jobIds: string[]
        queuedCount: number
        message: string
    }> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<{
                jobIds: string[]
                queuedCount: number
                message: string
            }> & { statusCode?: number }
        >(API.QueueOptionExtraction(), body, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async triggerSwatchExtraction(body: { productId?: string }): Promise<{
        jobIds: string[]
        queuedCount: number
        message: string
    }> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<{
                jobIds: string[]
                queuedCount: number
                message: string
            }> & { statusCode?: number }
        >(API.QueueSwatchExtraction(), body, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async triggerVirtualProductSetup(
        delimiter: string,
    ): Promise<QueueVirtualProductSetupResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<QueueVirtualProductSetupResponse> & {
                statusCode?: number
            }
        >(API.QueueVirtualProductSetup(), { delimiter }, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async updateCollection(
        collectionHash: string,
        collectionData: UpdateCollectionInput,
    ): Promise<UpdateCollectionResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<UpdateCollectionResponse>
        >(
            API.UpdateCollection(collectionHash),
            {
                ...collectionData,
            },
            { method: 'post' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async deleteCollection(
        collectionHash: string,
    ): Promise<DeleteCollectionResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<DeleteCollectionResponse>
        >(API.DeleteCollection(collectionHash), {}, { method: 'delete' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    // Landing Pages
    async getAllLandingPages(): Promise<GetAllLandingPagesResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetAllLandingPagesResponse>
        >(API.GetAllLandingPages(), {}, { method: 'get' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async getLandingPage(
        landingPageHash: string,
    ): Promise<GetLandingPageResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetLandingPageResponse>
        >(API.GetLandingPage(landingPageHash), {}, { method: 'get' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async getLandingPageSourceAd(
        landingPageHash: string,
    ): Promise<GetLandingPageSourceAdResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetLandingPageSourceAdResponse>
        >(API.GetLandingPageSourceAd(landingPageHash), {}, { method: 'get' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async getLandingPageOrderLineItemSummary(
        landingPageHash: string,
    ): Promise<GetLandingPageOrderLineItemSummaryResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetLandingPageOrderLineItemSummaryResponse>
        >(
            API.GetLandingPageOrderLineItemSummary(landingPageHash),
            {},
            { method: 'get' },
        )

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async getLandingPageContent(
        landingPageHash: string,
    ): Promise<{ bodyContent: any }> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<{ bodyContent: any }>
        >(API.GetLandingPageContent(landingPageHash), {}, { method: 'get' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async getTemplatePreview(
        landingPageHash: string,
    ): Promise<GetLandingPageResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetLandingPageResponse>
        >(API.GetTemplatePreview(landingPageHash), {}, { method: 'get' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async getAllLandingPageTemplates(): Promise<GetAllLandingPageTemplateResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetAllLandingPageTemplateResponse>
        >(API.GetAllLandingPageTemplates(), {}, { method: 'get' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async createLandingPageTemplate(
        req: CreateLandingPageTemplateRequestBody,
    ): Promise<CreateLandingPageTemplateResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<CreateLandingPageTemplateResponse>
        >(API.CreateLandingPageTemplate(), { ...req }, { method: 'post' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async updateLandingPageTemplate(
        templateId: number,
        req: UpdateLandingPageTemplateRequestBody,
    ): Promise<UpdateLandingPageTemplateResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<UpdateLandingPageTemplateResponse>
        >(
            API.UpdateLandingPageTemplate(templateId),
            { ...req },
            { method: 'put' },
        )

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async deleteLandingPageTemplate(
        templateId: number,
    ): Promise<DeleteLandingPageTemplateResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<DeleteLandingPageTemplateResponse>
        >(API.DeleteLandingPageTemplate(templateId), {}, { method: 'delete' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async getAllStorefrontGeneratorLandingPages(
        req?: GetAllStorefrontGeneratorLandingPagesRequest,
    ): Promise<GetAllStorefrontGeneratorLandingPagesResponse> {
        const queryParams = req
            ? { statuses: req.statuses.join(',') }
            : undefined
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetAllStorefrontGeneratorLandingPagesResponse>
        >(API.GetAllStorefrontGeneratorLandingPages(), queryParams, {
            method: 'get',
        })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async createLandingPage(
        req: CreateLandingPageRequestBody,
    ): Promise<CreateLandingPageResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<CreateLandingPageResponse>
        >(
            API.CreateLandingPage(),
            {
                ...req,
            },
            { method: 'post' },
        )

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async duplicateLandingPage(
        req: DuplicateLandingPageRequestBody,
    ): Promise<DuplicateLandingPageResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<DuplicateLandingPageResponse>
        >(
            API.DuplicateLandingPage(),
            {
                ...req,
            },
            { method: 'post' },
        )

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async updateLandingPage(
        req: UpdateLandingPageRequestBody,
    ): Promise<UpdateLandingPageResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<UpdateLandingPageResponse>
        >(
            API.UpdateLandingPage(),
            {
                ...req,
            },
            { method: 'post' },
        )

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async updateLandingPageContent(
        req: UpdateLandingPageContentRequestBody,
    ): Promise<UpdateLandingPageContentResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<UpdateLandingPageContentResponse>
        >(
            API.UpdateLandingPageContent(),
            {
                ...req,
            },
            { method: 'post' },
        )

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async updateLandingPageLinks(
        req: UpdateLandingPageLinksBody,
    ): Promise<UpdateLandingPageLinksResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<UpdateLandingPageLinksResponse>
        >(
            API.UpdateLandingPageLinks(),
            {
                ...req,
            },
            { method: 'post' },
        )

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async updateCartUpsellLinks(
        req: UpdateLandingPageCartUpsellsBody,
    ): Promise<UpdateLandingPageCartUpsellsResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<UpdateLandingPageCartUpsellsResponse>
        >(
            API.UpdateLandingPageCartUpsells(),
            {
                ...req,
            },
            { method: 'post' },
        )

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async saveLandingPage(
        landingPageHash: string,
        payload: SaveLandingPagePayload,
    ): Promise<SaveLandingPageResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<SaveLandingPageResponse>
        >(
            API.SaveLandingPage(landingPageHash),
            { ...payload },
            { method: 'post' },
        )

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async listPlacementOptionRules(
        landingPageHash: string,
    ): Promise<ListPlacementOptionRulesResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<ListPlacementOptionRulesResponse>
        >(API.ListPlacementOptionRules(landingPageHash), {}, { method: 'get' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async getPlacementOptionRulesForLink(
        landingPageHash: string,
        linkHash: string,
    ): Promise<GetPlacementOptionRulesForLinkResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetPlacementOptionRulesForLinkResponse>
        >(
            API.GetPlacementOptionRulesForLink(landingPageHash, linkHash),
            {},
            { method: 'get' },
        )

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async createPlacementOptionRule(
        landingPageHash: string,
        linkHash: string,
        body: CreatePlacementOptionRuleRequestBody,
    ): Promise<{ rule: PlacementOptionRule }> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<{ rule: PlacementOptionRule }>
        >(API.CreatePlacementOptionRule(landingPageHash, linkHash), body, {
            method: 'post',
        })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async updatePlacementOptionRule(
        landingPageHash: string,
        ruleId: number,
        body: UpdatePlacementOptionRuleRequestBody,
    ): Promise<{ rule: PlacementOptionRule }> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<{ rule: PlacementOptionRule }>
        >(API.UpdatePlacementOptionRule(landingPageHash, ruleId), body, {
            method: 'put',
        })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async deletePlacementOptionRule(
        landingPageHash: string,
        ruleId: number,
    ): Promise<{ success: true }> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<{ success: true }>
        >(
            API.DeletePlacementOptionRule(landingPageHash, ruleId),
            {},
            { method: 'delete' },
        )

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async deleteAllPlacementOptionRulesForLink(
        landingPageHash: string,
        linkHash: string,
    ): Promise<DeleteAllPlacementOptionRulesForLinkResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<DeleteAllPlacementOptionRulesForLinkResponse>
        >(
            API.DeleteAllPlacementOptionRulesForLink(landingPageHash, linkHash),
            {},
            { method: 'delete' },
        )

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    // Storefront Tags
    async getStorefrontTags(): Promise<GetStorefrontTagsResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetStorefrontTagsResponse>
        >(API.GetStorefrontTags(), {}, { method: 'get' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async createStorefrontTag(
        body: CreateStorefrontTagRequestBody,
    ): Promise<CreateStorefrontTagResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<CreateStorefrontTagResponse>
        >(API.CreateStorefrontTag(), body, { method: 'post' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async renameStorefrontTag(
        tagHash: string,
        body: RenameStorefrontTagRequestBody,
    ): Promise<RenameStorefrontTagResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<RenameStorefrontTagResponse>
        >(API.RenameStorefrontTag(tagHash), body, { method: 'post' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async deleteStorefrontTag(
        tagHash: string,
    ): Promise<DeleteStorefrontTagResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<DeleteStorefrontTagResponse>
        >(API.DeleteStorefrontTag(tagHash), {}, { method: 'delete' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async assignStorefrontTag(
        req: AssignStorefrontTagRequestBody,
    ): Promise<AssignStorefrontTagResponse> {
        // tagHash is addressed by the route, not the body.
        const { path, body } =
            'tagHash' in req
                ? (() => {
                      const { tagHash, ...rest } = req
                      return {
                          path: API.AssignStorefrontTagByHash(tagHash),
                          body: rest,
                      }
                  })()
                : { path: API.AssignStorefrontTag(), body: req }

        const response = await this.makeAuthenticatedRequest<
            ApiResponse<AssignStorefrontTagResponse>
        >(path, body, { method: 'post' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    // Gift Promotions
    async getGiftPromotions(): Promise<GetGiftPromotionsResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetGiftPromotionsResponse>
        >(API.GetGiftPromotions(), {}, { method: 'get' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async createGiftPromotion(
        body: CreateGiftPromotionRequestBody,
    ): Promise<CreateGiftPromotionResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<CreateGiftPromotionResponse>
        >(API.CreateGiftPromotion(), body, { method: 'post' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async updateGiftPromotion(
        giftPromotionHash: string,
        body: UpdateGiftPromotionRequestBody,
    ): Promise<UpdateGiftPromotionResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<UpdateGiftPromotionResponse>
        >(API.UpdateGiftPromotion(giftPromotionHash), body, { method: 'post' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async deleteGiftPromotion(
        giftPromotionHash: string,
    ): Promise<DeleteGiftPromotionResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<DeleteGiftPromotionResponse>
        >(API.DeleteGiftPromotion(giftPromotionHash), {}, { method: 'delete' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    // Landing Page Links
    async getAllLandingPageLinks(): Promise<GetAllLandingPageLinksResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetAllLandingPageLinksResponse>
        >(API.GetAllLandingPageLinks(), {}, { method: 'get' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        const result = response.result
        return {
            landingPageLinks: applySharedProductDataToLinks(
                result.landingPageLinks,
                result.sharedProductData,
            ) as GetAllLandingPageLinksResponse['landingPageLinks'],
        }
    }

    async getPaginatedLandingPageLinks({
        page,
        size,
        searchText,
    }: GetPaginatedLandingPageLinksRequest): Promise<GetPaginatedLandingPageLinksResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetPaginatedLandingPageLinksResponse>
        >(
            API.GetPaginatedLandingPageLinks(),
            {
                page,
                size,
                ...(searchText ? { search: searchText } : {}),
            },
            { method: 'get' },
        )

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        const result = response.result
        return {
            landingPageLinks: applySharedProductDataToLinks(
                result.landingPageLinks,
                result.sharedProductData,
            ) as GetPaginatedLandingPageLinksResponse['landingPageLinks'],
            meta: result.meta,
        }
    }

    async getLandingPageLink(
        linkHash: string,
        includeProductFamilies = false,
    ): Promise<GetLandingPageLinkResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetLandingPageLinkResponse>
        >(
            API.GetLandingPageLink(linkHash),
            includeProductFamilies ? { siblings: '1' } : {},
            { method: 'get' },
        )

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async getLandingPageLinksBatch(
        linkHashes: string[],
        landingPageHash?: string,
    ): Promise<GetLandingPageLinksBatchResponseBody> {
        const body: GetLandingPageLinksBatchRequestBody = {
            linkHashes,
            ...(landingPageHash ? { landingPageHash } : {}),
        }
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetLandingPageLinksBatchResponseBody>
        >(API.GetLandingPageLinksBatch(), body, { method: 'post' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        const result = response.result
        return {
            landingPageLinks: applySharedProductDataToLinks(
                result.landingPageLinks,
                result.sharedProductData,
            ),
            missingLinkHashes: result.missingLinkHashes,
        }
    }

    async getLandingPageLinkByVirtualProductId(
        virtualProductId: number,
    ): Promise<GetLandingPageLinkResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetLandingPageLinkResponse>
        >(
            API.GetLandingPageLinkByVirtualProductId(virtualProductId),
            {},
            { method: 'get' },
        )

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async updateLandingPageLinkMetadata(
        req: UpdateLandingPageLinkRequestBody,
    ): Promise<UpdateLandingPageLinkResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<UpdateLandingPageLinkResponse>
        >(
            API.UpdateLandingPageLinkMetadata(),
            {
                ...req,
            },
            { method: 'post' },
        )

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async updateLandingPageLinkContent(
        bodyContent: UpdateLandingPageLinkContentRequest,
    ): Promise<UpdateLandingPageLinkContentResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<UpdateLandingPageLinkContentResponse>
        >(
            API.UpdateLandingPageLinkContent(),
            {
                ...bodyContent,
            },
            { method: 'post' },
        )

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async getAllProductsOrderedByRelevanceToMetaAd(
        metaAdId: string,
        req: GetAllProductsOrderedByRelevanceToMetaAdRequest,
    ): Promise<GetAllProductsOrderedByRelevanceToMetaAdResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetAllProductsOrderedByRelevanceToMetaAdResponse>
        >(
            API.GetAllProductsOrderedByRelevanceToMetaAd(metaAdId),
            {
                ...req,
            },
            { method: 'post' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getAllProductsOrderedByRelevance(
        req: GetAllProductsOrderedByRelevanceToMetaAdRequest,
    ): Promise<GetAllProductsOrderedByRelevanceToMetaAdResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetAllProductsOrderedByRelevanceToMetaAdResponse>
        >(
            API.GetAllProductsOrderedByRelevance(),
            {
                ...req,
            },
            { method: 'post' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getAllShopifyCollections(
        req: GetClientAllShopifyCollectionsRequest,
    ): Promise<GetClientAllShopifyCollectionsResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetClientAllShopifyCollectionsResponse>
        >(
            API.GetAllShopifyCollections(),
            {
                ...req,
            },
            { method: 'post' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getAllShopifyProducts(
        req: GetClientAllShopifyProductsRequest,
    ): Promise<GetClientAllShopifyProductsResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetClientAllShopifyProductsResponse>
        >(
            API.GetAllShopifyProducts(),
            {
                ...req,
            },
            { method: 'post' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getAllUnimportedShopifyProducts(
        queryParams: GetClientUnimportedShopifyProductsRequest,
    ): Promise<GetClientUnimportedShopifyProductsResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetClientUnimportedShopifyProductsResponse>
        >(API.GetAllUnimportedShopifyProducts(), queryParams, {
            method: 'post',
        })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async importShopifyProduct(
        productShopifyId: string,
    ): Promise<ImportShopifyProductResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<ImportShopifyProductResponse>
        >(
            API.ImportShopifyProduct(),
            {
                shopifyProductId: productShopifyId,
            },
            { method: 'post' },
        )

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async importShopifyCollection(
        collectionShopifyId: string,
    ): Promise<ImportShopifyCollectionResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<ImportShopifyCollectionResponse>
        >(
            API.ImportShopifyCollection(),
            {
                shopifyCollectionId: collectionShopifyId,
            },
            { method: 'post' },
        )

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async batchImportTopProducts(
        topProductCount: number,
    ): Promise<BatchImportTopProductsResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<BatchImportTopProductsResponse>
        >(
            API.BatchImportTopProducts(),
            {
                topProductCount,
            },
            { method: 'post' },
        )

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async resyncImagesForLandingPageLink(
        input: ResyncimagesForLandingPageLinkRequestBody,
    ): Promise<ResyncimagesForLandingPageLinkResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<ResyncimagesForLandingPageLinkResponse>
        >(API.ResyncImagesForLandingPageLink(), input, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async regeneratePDPForLandingPageLink(
        input: RegeneratePDPForLandingPageLinkRequestBody,
    ): Promise<RegeneratePDPForLandingPageLinkResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<RegeneratePDPForLandingPageLinkResponse>
        >(API.RegeneratePDPForLandingPageLink(), input, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getPDPRegenerationStatus(
        jobId: string,
    ): Promise<PDPRegenerationStatusResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<PDPRegenerationStatusResponse>
        >(API.GetPDPRegenerationStatus(jobId), {}, { method: 'get' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async regenerateAllPDPs(
        input: RegenerateAllPDPsRequestBody,
    ): Promise<RegenerateAllPDPsResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<RegenerateAllPDPsResponse>
        >(API.RegenerateAllPDPs(), input, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async queueReviewAnalysisForLandingPageLink(
        landingPageLinkHash: string,
    ): Promise<QueueReviewAnalysisForLandingPageLinkResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<QueueReviewAnalysisForLandingPageLinkResponse>
        >(API.QueueReviewAnalysis(landingPageLinkHash), {}, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async queueReviewAnalysisForAllClientLinks(): Promise<QueueReviewAnalysisForAllClientLinksResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<QueueReviewAnalysisForAllClientLinksResponse>
        >(API.QueueAllReviewAnalysis(), {}, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async triggerDiscountSync(): Promise<TriggerDiscountSyncResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<TriggerDiscountSyncResponse>
        >(API.TriggerDiscountSync(), {}, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getDiscountSyncStatus(): Promise<GetDiscountSyncStatusResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetDiscountSyncStatusResponse>
        >(API.GetDiscountSyncStatus(), {}, { method: 'get' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getActivePDPJobsCount(): Promise<{ activeCount: number }> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<{ activeCount: number }>
        >(API.GetActivePDPJobsCount(), {}, { method: 'get' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getDynamicGridProductsBatch(
        featuredLinkHash: string | undefined,
        sections: GetDynamicGridProductsBatchRequestBody['sections'],
    ): Promise<GetDynamicGridProductsBatchResponse> {
        const body: GetDynamicGridProductsBatchRequestBody = {
            featuredLinkHash,
            sections,
        }
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetDynamicGridProductsBatchResponse>
        >(API.GetDynamicGridProductsBatch(), body, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getCollectionsForProduct(
        linkHash: string,
    ): Promise<GetCollectionsForProductResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetCollectionsForProductResponse>
        >(API.GetCollectionsForProduct(linkHash), {}, { method: 'get' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    // Images
    async getAllImages(): Promise<GetAllImagesResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetAllImagesResponse>
        >(API.GetAllImages())

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async uploadImage(
        file: File,
        metadata?: Omit<UploadLocalImageInput, 'source'>,
    ): Promise<UploadImageResponse> {
        const formData = new FormData()
        formData.append('source', file, file.name)

        // Add optional metadata fields
        if (metadata?.name) {
            formData.append('name', metadata.name)
        }
        if (metadata?.displayName) {
            formData.append('displayName', metadata.displayName)
        }

        if (!this.client) {
            throw new Error('No client')
        }

        const jwt = window.localStorage.getItem(LocalStorageKey.JWT)

        if (!jwt) {
            redirectToLogin()
        }

        const headers = {
            Authorization: `Bearer ${jwt}`,
        }

        const fullPath = `api/client/${this.client}/${API.UploadImage()}`

        const url = `${config('API_BASEURL')}/${fullPath}`

        const resp = await fetch(url, {
            method: 'post',
            headers,
            body: formData,
        })

        const response = await resp.json()

        if (resp.status == 401) {
            redirectToLogin()
        }

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }
        return response.result
    }

    async uploadImages(files: File[]): Promise<UploadImagesResponse> {
        const formData = new FormData()
        files.forEach((file) => {
            formData.append(`files[]`, file, file.name)
        })

        if (!this.client) {
            throw new Error('No client')
        }

        const jwt = window.localStorage.getItem(LocalStorageKey.JWT)

        if (!jwt) {
            redirectToLogin()
        }

        const headers = {
            Authorization: `Bearer ${jwt}`,
        }

        const fullPath = `api/client/${this.client}/${API.UploadImages()}`

        const url = `${config('API_BASEURL')}/${fullPath}`

        const resp = await fetch(url, {
            method: 'post',
            headers,
            body: formData,
        })

        const response = await resp.json()

        if (resp.status == 401) {
            redirectToLogin()
        }

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }
        return response.result
    }

    async getAvailableClients(): Promise<GetAvailableClientsResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetAvailableClientsResponse>
        >(API.GetAvailableClients(), {}, { method: 'get' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async getMetaAds(): Promise<MetaAd[]> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<MetaAdResponse>
        >(API.GetMetaAds(), {}, { method: 'get' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result.ads
    }

    async getTemplatesRankedByAi(
        input: GetTemplatesRankedInput,
    ): Promise<GetTemplatesRankedResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetTemplatesRankedResponse>
        >(API.GetTemplatesRankedByAi(), input, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getShopifyProductById(
        shopifyId: string,
    ): Promise<AdminShopifyProduct> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<{ product: AdminShopifyProduct }>
        >(API.GetShopifyProductById(shopifyId), {}, { method: 'get' })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result.product
    }

    async getExploCustomerToken(
        dashboardType?: ExploDashboardType,
    ): Promise<ExploCustomerTokenResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<ExploCustomerTokenResponse>
        >(API.GetExploCustomerToken(), dashboardType ? { dashboardType } : {}, {
            method: 'post',
        })

        if (response.isError) {
            console.log(response)
            throw new Error(response.message)
        }

        return response.result
    }

    async getFullFunnelAggregationMetrics(): Promise<FullFunnelAggregationsResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<FullFunnelAggregationsResponse>
        >(API.GetFullFunnelAggregations(), {}, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getFunnelReport(
        reportDateStart: string,
        reportDateEnd: string,
    ): Promise<FunnelReportResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<FunnelReportResponse>
        >(
            API.GetFunnelReport(),
            { reportDateStart, reportDateEnd },
            { method: 'post' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getFunnelOverviewMetrics(): Promise<FunnelOverviewResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<FunnelOverviewResponse>
        >(API.GetFunnelOverviewMetrics(), {}, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getTopPerformingCreatives(): Promise<TopPerformingCreativesResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<TopPerformingCreativesResponse>
        >(API.GetTopPerformingCreatives(), {}, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getLiveExperiments(): Promise<LiveExperimentsResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<LiveExperimentsResponse>
        >(API.GetLiveExperiments(), {}, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getExperimentsList(
        channel?: ExperimentType,
    ): Promise<ExperimentsListResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<ExperimentsListResponse>
        >(API.GetExperimentsList(), channel ? { channel } : {}, {
            method: 'get',
        })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getExperimentMetrics(
        experimentId: string,
        experimentType?: 'paid' | 'owned',
    ): Promise<ExperimentMetricsResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<ExperimentMetricsResponse>
        >(
            API.GetExperimentMetrics(experimentId),
            experimentType ? { experimentType } : {},
            { method: 'post' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getStorefrontMetrics(landingPageHashes: string[], days: number) {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<StorefrontMetricsResponse>
        >(
            API.GetStorefrontMetrics(),
            { landingPageHashes, days },
            { method: 'post' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getAllCrowLinks(): Promise<AdminCrowLink[]> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetAllCrowLinksResponse>
        >(API.GetAllCrowLinks(), {}, { method: 'get' })
        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result.crowLinks
    }

    async getCrowLink(linkHash: string): Promise<ApiCrowLink> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetCrowLinkResponse>
        >(API.GetCrowLink(linkHash), {}, { method: 'get' })
        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result.crowLink
    }

    async getCrowLinksByLandingPage(
        landingPageHash: string,
    ): Promise<ApiCrowLink[]> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetCrowLinksByLandingPageResponse>
        >(API.GetCrowLinksByLandingPage(landingPageHash), {}, { method: 'get' })
        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result.crowLinks
    }

    async createCrowLink(
        body: CreateCrowLinkRequest,
    ): Promise<CreateCrowLinkResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<CreateCrowLinkResponse>
        >(
            API.CreateCrowLink(),
            {
                ...body,
            },
            { method: 'post' },
        )
        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async createExperimentGroup(
        body: CreateExperimentGroupRequest,
    ): Promise<CreateExperimentGroupResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<CreateExperimentGroupResponse>
        >(
            API.CreateExperimentGroup(),
            {
                ...body,
            },
            { method: 'post' },
        )
        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async createManyCrowLinks(
        body: CreateManyCrowLinksRequest,
    ): Promise<CreateManyCrowLinksResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<CreateManyCrowLinksResponse>
        >(
            API.CreateManyCrowLinks(),
            {
                ...body,
            },
            { method: 'post' },
        )
        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async updateCrowLink(
        linkHash: string,
        body: UpdateCrowLinkRequest,
    ): Promise<UpdateCrowLinkResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<UpdateCrowLinkResponse>
        >(
            API.UpdateCrowLink(linkHash),
            {
                ...body,
            },
            { method: 'post' },
        )
        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async getExperimentDetails(
        experimentId: string,
        crowlinkHash?: string,
    ): Promise<ExperimentDetailsResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<ExperimentDetailsResponse>
        >(
            API.GetExperimentDetails(experimentId),
            crowlinkHash ? { crowlinkHash } : {},
            { method: 'get' },
        )
        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async updateExperimentDetails(
        experimentId: string,
        body: UpdateExperimentDetailsRequest,
    ): Promise<ExperimentDetailsResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<ExperimentDetailsResponse>
        >(API.UpdateExperimentDetails(experimentId), body, { method: 'post' })
        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    async signup(email: string): Promise<{ success: boolean }> {
        const response = await fetch(`${config('API_BASEURL')}/auth/signup`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                username: email,
            }),
        })

        const data = await response.json()

        if (data.isError) {
            throw new Error(data.message || 'Failed to create account')
        }

        return data.result
    }

    async getAllPersonas(): Promise<{ personas: Persona[] }> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<{ personas: Persona[] }>
        >(API.GetAllPersonas(), {}, { method: 'get' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async createAICreateSession(
        body: CreateAICreateSessionRequestBody,
    ): Promise<CreateAICreateSessionResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<CreateAICreateSessionResponse>
        >(API.CreateAICreateSession(), { ...body }, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async createAICreateSessionFromMetaAd(
        adId: string,
        platform?: AdPlatform,
        variantCount?: number,
        userInput?: string,
        preselections?: AICreatePreselections,
        referenceUrl?: string,
    ): Promise<CreateAICreateSessionResponse> {
        return this.createAICreateSession({
            source: AI_CREATE_SESSION_SOURCE.META_AD,
            adId,
            platform,
            variantCount,
            userInput,
            startRun: true,
            referenceUrl,
            ...preselections,
        })
    }

    async createAICreateSessionManual(
        assets: { mediaType: 'IMAGE' | 'VIDEO'; creativeUrl: string }[],
        adCreativeBody?: string,
        adDeepLinkUrl?: string,
        adName?: string,
        platform?: AdPlatform,
        variantCount?: number,
        userInput?: string,
        preselections?: AICreatePreselections,
        referenceUrl?: string,
    ): Promise<CreateAICreateSessionResponse> {
        return this.createAICreateSession({
            source: AI_CREATE_SESSION_SOURCE.MANUAL,
            assets,
            adCreativeBody,
            adDeepLinkUrl,
            adName,
            platform,
            variantCount,
            adMediaType: assets.length === 0 ? 'IMAGE' : undefined,
            startRun: true,
            userInput,
            referenceUrl,
            ...preselections,
        })
    }

    async createAICreateSessionFromSearchQuery(
        searchQuery: string,
        currentLandingPageUrl?: string,
        platform?: AdPlatform,
        variantCount?: number,
        userInput?: string,
        preselections?: AICreatePreselections,
        referenceUrl?: string,
    ): Promise<CreateAICreateSessionResponse> {
        return this.createAICreateSession({
            source: AI_CREATE_SESSION_SOURCE.SEARCH_QUERY,
            searchQuery,
            currentLandingPageUrl,
            platform,
            variantCount,
            userInput,
            startRun: true,
            referenceUrl,
            ...preselections,
        })
    }

    async createAICreateSessionRun(
        sessionId: string,
        userInput?: string,
    ): Promise<CreateAICreateSessionRunResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<CreateAICreateSessionRunResponse>
        >(
            API.CreateAICreateSessionRun(sessionId),
            { userInput },
            { method: 'post' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async createS3UploadUrlForVideo(
        contentType: string,
    ): Promise<CreateS3UploadUrlResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<CreateS3UploadUrlResponse>
        >(API.CreateS3UploadUrlForVideo(), { contentType }, { method: 'post' })
        if (response.isError) {
            throw new Error(response.message)
        }
        return response.result
    }

    /** EventSource URL for AI create session SSE (JWT via custom fetch). */
    getAICreateSessionEventsUrl(sessionId: string): string {
        return `${this.apiBaseUrl}/${API.GetAICreateSessionEvents(sessionId)}`
    }

    /** EventSource URL for create-chat AG-UI SSE (JWT via custom fetch). */
    getAICreateSessionAgUiEventsUrl(sessionId: string): string {
        return `${this.apiBaseUrl}/${API.GetAICreateSessionAgUiEvents(sessionId)}`
    }

    async createEditChatSession(
        landingPageHash: string,
    ): Promise<CreateEditChatSessionResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<CreateEditChatSessionResponse>
        >(API.CreateEditChatSession(landingPageHash), {}, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getEditChatSession(
        landingPageHash: string,
        sessionId: string,
    ): Promise<GetEditChatSessionResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetEditChatSessionResponse>
        >(
            API.GetEditChatSession(landingPageHash, sessionId),
            {},
            { method: 'get' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async postEditChatMessage(
        landingPageHash: string,
        sessionId: string,
        body: PostEditChatMessageRequestBody,
        signal?: AbortSignal,
    ): Promise<PostEditChatMessageResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<PostEditChatMessageResponse>
        >(
            API.PostEditChatMessage(landingPageHash, sessionId),
            { ...body },
            {
                method: 'post',
                signal,
            },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async cancelEditChatTurn(
        landingPageHash: string,
        sessionId: string,
    ): Promise<CancelEditChatTurnResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<CancelEditChatTurnResponse>
        >(
            API.CancelEditChatTurn(landingPageHash, sessionId),
            {},
            { method: 'post' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getStorefrontAiFeedbackEligibility(
        landingPageHash: string,
    ): Promise<GetStorefrontAiFeedbackEligibilityResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetStorefrontAiFeedbackEligibilityResponse>
        >(API.PostStorefrontAiFeedback(landingPageHash), {}, { method: 'get' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async postEditChatMessageFeedback(
        landingPageHash: string,
        sessionId: string,
        messageId: string,
        body: PostStorefrontAiFeedbackRequestBody,
    ): Promise<PostStorefrontAiFeedbackResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<PostStorefrontAiFeedbackResponse>
        >(
            API.PostEditChatMessageFeedback(
                landingPageHash,
                sessionId,
                messageId,
            ),
            { ...body },
            { method: 'post' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async postCropFit(
        landingPageHash: string,
        body: PostCropFitRequestBody,
    ): Promise<PostCropFitResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<PostCropFitResponse>
        >(API.PostCropFit(landingPageHash), { ...body }, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async postStorefrontAiFeedback(
        landingPageHash: string,
        body: PostStorefrontAiFeedbackRequestBody,
    ): Promise<PostStorefrontAiFeedbackResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<PostStorefrontAiFeedbackResponse>
        >(
            API.PostStorefrontAiFeedback(landingPageHash),
            { ...body },
            { method: 'post' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    /** EventSource URL for edit-chat AG-UI SSE (JWT via custom fetch). */
    getEditChatAgUiEventsUrl(
        landingPageHash: string,
        sessionId: string,
    ): string {
        return `${this.apiBaseUrl}/${API.GetEditChatAgUiEvents(
            landingPageHash,
            sessionId,
        )}`
    }

    async getEditChatAttachmentUploadSignature(
        landingPageHash: string,
    ): Promise<GetEditChatAttachmentUploadSignatureResponse> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<GetEditChatAttachmentUploadSignatureResponse>
        >(
            API.GetEditChatAttachmentUploadSignature(landingPageHash),
            {},
            { method: 'get' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async createPersona(
        data: Omit<Persona, 'id' | 'createdAt' | 'updatedAt' | 'clientId'>,
    ): Promise<{ persona: Persona }> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<{ persona: Persona }>
        >(API.CreatePersona(), data, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async updatePersona(
        id: number,
        data: Omit<Persona, 'id' | 'createdAt' | 'updatedAt' | 'clientId'>,
    ): Promise<{ persona: Persona }> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<{ persona: Persona }>
        >(API.UpdatePersona(id), data, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async queuePersonaGeneration(
        userInput?: string,
    ): Promise<{ message: string }> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<{ message: string }>
        >(API.QueuePersonaGeneration(), { userInput }, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async getPersonaGenerationStatus(): Promise<{
        status: string
        count: number
    }> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<{ status: string; count: number }>
        >(API.PersonaGenerationStatus(), {}, { method: 'get' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async deletePersona(id: number): Promise<void> {
        const response = await this.makeAuthenticatedRequest<ApiResponse<void>>(
            API.DeletePersona(id),
            {},
            { method: 'delete' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }
    }

    async sendMagicLink(email: string) {
        return await fetch(`${config('API_BASEURL')}/auth/magic-link`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
        })
    }

    async verifyMagicLink(token: string) {
        return await fetch(`${config('API_BASEURL')}/auth/verify-magic-link`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token }),
        })
    }

    async inviteUser(data: {
        email: string
        role: string
    }): Promise<ApiResponse<any>> {
        return await this.makeAuthenticatedRequest<ApiResponse<any>>(
            'users/invite',
            data,
            { method: 'post' },
        )
    }

    async createSupportTicket(
        data: CreateSupportTicketRequest,
    ): Promise<ApiResponse<CreateSupportTicketResponse>> {
        return await this.makeAuthenticatedRequest<
            ApiResponse<CreateSupportTicketResponse>
        >(
            'support-tickets',
            {
                title: data.title,
                description: data.description,
                pageUrl: data.pageUrl,
                screenshot: data.screenshot,
            },
            { method: 'post' },
        )
    }

    async verifyInviteLink(token: string) {
        return await fetch(`${config('API_BASEURL')}/auth/verify-invite-link`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token }),
        })
    }

    async deleteUser(data: { email: string }): Promise<ApiResponse<any>> {
        const response = await this.makeAuthenticatedRequest<ApiResponse<any>>(
            API.DeleteUser(),
            data,
            { method: 'delete' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response
    }

    async updateUser(data: {
        email: string
        role?: string
        // Add future user update fields here as needed
    }): Promise<ApiResponse<any>> {
        const response = await this.makeAuthenticatedRequest<ApiResponse<any>>(
            API.UpdateUser(),
            data,
            { method: 'post' },
        )

        if (response.isError) {
            throw new Error(response.message)
        }

        return response
    }

    // Keep this for backward compatibility, but it uses the more general updateUser method
    async updateUserRole(data: {
        email: string
        role: string
    }): Promise<ApiResponse<any>> {
        return this.updateUser(data)
    }

    async sendAppInstallEmail(email: string) {
        return await fetch(
            `${config('API_BASEURL')}/auth/send-app-install-email`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            },
        )
    }

    async syncMetaAccess(): Promise<ApiResponse<any>> {
        return await this.makeAuthenticatedRequest<ApiResponse<any>>(
            'client/sync-meta-access',
            {},
            { method: 'post' },
        )
    }

    async getFacebookAppInstallUrl(): Promise<{ installUrl: string }> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<{ installUrl: string }>
        >(API.GetFacebookAppInstallUrl(), {}, { method: 'get' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async createCheckoutSession(): Promise<ApiResponse<{ url: string }>> {
        return this.makeAuthenticatedRequest<ApiResponse<{ url: string }>>(
            'subscription/checkout',
            {},
            { method: 'post' },
        )
    }

    async checkoutCompleted(data: { sessionId: string }) {
        return this.makeAuthenticatedRequest('subscription/completed', data, {
            method: 'post',
        })
    }

    async createBillingPortalSession(): Promise<ApiResponse<{ url: string }>> {
        return this.makeAuthenticatedRequest<ApiResponse<{ url: string }>>(
            'subscription/billing',
            {},
            { method: 'post' },
        )
    }

    async uploadReviewsCsv(file: File): Promise<void> {
        // Get presigned URL from backend
        const createUrlResponse = await this.makeAuthenticatedRequest<
            ApiResponse<{ uploadUrl: string; tempId: string }>
        >(API.UploadReviewsCsvCreateURL(), {}, { method: 'post' })

        if (createUrlResponse.isError) {
            throw new Error(createUrlResponse.message)
        }

        const { uploadUrl, tempId } = createUrlResponse.result

        // Upload file directly to S3 using presigned URL
        const uploadResponse = await fetch(uploadUrl, {
            method: 'put',
            body: file,
            headers: {
                'Content-Type': 'text/csv',
            },
        })

        if (!uploadResponse.ok) {
            throw new Error('Failed to upload file to S3')
        }

        // Process file
        const processFileResponse = await this.makeAuthenticatedRequest<
            ApiResponse<{ message: string }>
        >(API.ProcessReviewsCsv(), { tempId }, { method: 'post' })

        if (processFileResponse.isError) {
            throw new Error(processFileResponse.message)
        }
    }

    // Client Settings Endpoints
    async getClientSettings(
        clientHash: string,
    ): Promise<ApiResponse<GetClientSettingsResponse>> {
        return this.makeAuthenticatedRequest<
            ApiResponse<GetClientSettingsResponse>
        >(API.GetClientSettings(), { clientHash }, { method: 'get' })
    }

    async searchGoogleFonts(
        search: string,
    ): Promise<ApiResponse<SearchGoogleFontsResponse>> {
        return this.makeAuthenticatedRequest<
            ApiResponse<SearchGoogleFontsResponse>
        >(API.SearchGoogleFonts(), { search }, { method: 'get' })
    }

    async updateClientSettings(
        settings: Partial<AdminClientSettings>,
    ): Promise<ApiResponse<{ settings: AdminClientSettings }>> {
        return this.makeAuthenticatedRequest<
            ApiResponse<{ settings: AdminClientSettings }>
        >(API.UpdateClientSettings(), settings, { method: 'post' })
    }

    async updateGoogleFontFamily(
        fontType: FontSlot,
        fontFamily: string,
    ): Promise<ApiResponse<any>> {
        return this.makeAuthenticatedRequest<ApiResponse<any>>(
            API.UpdateGoogleFontFamily(),
            { fontType, fontFamily },
            { method: 'post' },
        )
    }

    async getCustomFontFamilies(): Promise<
        ApiResponse<GetCustomFontFamiliesResponse>
    > {
        return this.makeAuthenticatedRequest<
            ApiResponse<GetCustomFontFamiliesResponse>
        >(API.GetCustomFontFamilies(), {}, { method: 'get' })
    }

    async importWebsiteFonts(): Promise<
        ApiResponse<ImportWebsiteFontsResponse>
    > {
        return this.makeAuthenticatedRequest<
            ApiResponse<ImportWebsiteFontsResponse>
        >(API.ImportWebsiteFonts(), {}, { method: 'post' })
    }

    async uploadCustomFontFiles(
        files: File[],
    ): Promise<UploadCustomFontFilesResponse> {
        const formData = new FormData()
        files.forEach((file) => {
            formData.append('files', file, file.name)
        })

        if (!this.client) {
            throw new Error('No client')
        }

        const jwt = window.localStorage.getItem(LocalStorageKey.JWT)
        if (!jwt) {
            redirectToLogin()
        }

        const headers = {
            Authorization: `Bearer ${jwt}`,
        }

        const fullPath = `api/client/${this.client}/${API.UploadCustomFontFiles()}`
        const url = `${config('API_BASEURL')}/${fullPath}`

        const resp = await fetch(url, {
            method: 'post',
            headers,
            body: formData,
        })

        const response = await resp.json()

        if (resp.status == 401) {
            redirectToLogin()
        }

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }

    async updateCustomFontFamily(
        fontType: FontSlot,
        fontFamily: string,
    ): Promise<ApiResponse<UpdateCustomFontFamilyResponse>> {
        return this.makeAuthenticatedRequest<
            ApiResponse<UpdateCustomFontFamilyResponse>
        >(
            API.UpdateCustomFontFamily(),
            { fontType, fontFamily },
            { method: 'post' },
        )
    }

    async getTypographyRoleOverrides(): Promise<
        ApiResponse<GetTypographyRoleOverridesResponse>
    > {
        return this.makeAuthenticatedRequest<
            ApiResponse<GetTypographyRoleOverridesResponse>
        >(API.GetTypographyRoleOverrides(), {}, { method: 'get' })
    }

    async upsertTypographyRoleOverrides(
        body: UpsertTypographyRoleOverridesRequest,
    ): Promise<ApiResponse<UpsertTypographyRoleOverridesResponse>> {
        return this.makeAuthenticatedRequest<
            ApiResponse<UpsertTypographyRoleOverridesResponse>
        >(API.UpsertTypographyRoleOverrides(), body, { method: 'post' })
    }

    async getAllSubscriptions(): Promise<ApiResponse<AdminSellingPlanGroup[]>> {
        return this.makeAuthenticatedRequest<
            ApiResponse<AdminSellingPlanGroup[]>
        >(API.GetAllSubscriptions(), {}, { method: 'get' })
    }

    // Brand Guidelines
    async createBrandGuideline(
        content: string,
    ): Promise<ApiResponse<CreateBrandGuidelineResponse>> {
        return this.makeAuthenticatedRequest<
            ApiResponse<CreateBrandGuidelineResponse>
        >(API.CreateBrandGuideline(), { content }, { method: 'post' })
    }

    async updateBrandGuideline(
        id: number,
        content: string,
    ): Promise<ApiResponse<UpdateBrandGuidelineResponse>> {
        return this.makeAuthenticatedRequest<
            ApiResponse<UpdateBrandGuidelineResponse>
        >(API.UpdateBrandGuideline(id), { content }, { method: 'post' })
    }

    async deleteBrandGuideline(
        id: number,
    ): Promise<ApiResponse<DeleteBrandGuidelineResponse>> {
        return this.makeAuthenticatedRequest<
            ApiResponse<DeleteBrandGuidelineResponse>
        >(API.DeleteBrandGuideline(id), {}, { method: 'delete' })
    }

    async undoBrandGuideline(
        id: number,
        replacedId: number | null,
    ): Promise<ApiResponse<UndoBrandGuidelineResponse>> {
        return this.makeAuthenticatedRequest<
            ApiResponse<UndoBrandGuidelineResponse>
        >(API.UndoBrandGuideline(id), { replacedId }, { method: 'post' })
    }

    // Brand Benefits
    async bulkReplaceBrandBenefits(
        request: BulkUpdateBrandBenefitsRequest,
    ): Promise<ApiResponse<GetBrandBenefitsResponse>> {
        return this.makeAuthenticatedRequest<
            ApiResponse<GetBrandBenefitsResponse>
        >(
            API.BulkReplaceBrandBenefits(),
            { brandBenefits: request.brandBenefits },
            { method: 'post' },
        )
    }

    // Promotions
    async bulkReplacePromotions(
        request: BulkUpsertPromotionsRequest,
    ): Promise<ApiResponse<GetPromotionsResponse>> {
        return this.makeAuthenticatedRequest<
            ApiResponse<GetPromotionsResponse>
        >(
            API.BulkReplacePromotions(),
            { promotions: request.promotions },
            { method: 'post' },
        )
    }

    /** Live Shopify lookup of an entered discount code, for inline validation. */
    async lookupDiscountCode(
        code: string,
    ): Promise<ApiResponse<AdminDiscountCodeLookup>> {
        return this.makeAuthenticatedRequest<
            ApiResponse<AdminDiscountCodeLookup>
        >(API.DiscountCodeLookup(), { code }, { method: 'get' })
    }

    async createScheduledPromotion(
        request: UpsertScheduledPromotionRequest,
    ): Promise<ApiResponse<ScheduledPromotionResponse>> {
        return this.makeAuthenticatedRequest<
            ApiResponse<ScheduledPromotionResponse>
        >(API.CreateScheduledPromotion(), request, { method: 'post' })
    }

    async updateScheduledPromotion(
        id: number,
        request: UpsertScheduledPromotionRequest,
    ): Promise<ApiResponse<ScheduledPromotionResponse>> {
        return this.makeAuthenticatedRequest<
            ApiResponse<ScheduledPromotionResponse>
        >(API.ScheduledPromotion(id), request, { method: 'post' })
    }

    async deleteScheduledPromotion(
        id: number,
    ): Promise<ApiResponse<{ success: boolean }>> {
        return this.makeAuthenticatedRequest<ApiResponse<{ success: boolean }>>(
            API.ScheduledPromotion(id),
            {},
            { method: 'delete' },
        )
    }

    /** Deletes one promotion by server id */
    async deletePromotion(
        id: number,
    ): Promise<ApiResponse<{ success: boolean }>> {
        return this.makeAuthenticatedRequest<ApiResponse<{ success: boolean }>>(
            API.Promotion(id),
            {},
            { method: 'delete' },
        )
    }

    async getSlackChannelInvite(): Promise<
        ApiResponse<SlackChannelWithShareLink>
    > {
        return R.makeAuthenticatedRequest<
            ApiResponse<SlackChannelWithShareLink>
        >(
            API.GetSlackChannelInvite(),
            {}, // No parameters needed - backend uses client from URL path
            { method: 'POST' },
            false, // Use standard client-aware path pattern
        )
    }

    // Client Onboarding

    async getClientOnboarding(): Promise<
        ApiResponse<ClientOnboardingResponse>
    > {
        return this.makeAuthenticatedRequest<
            ApiResponse<ClientOnboardingResponse>
        >(API.GetClientOnboarding(), {}, { method: 'get' })
    }

    async updateClientOnboarding(
        onboarding: AdminClientOnboarding,
    ): Promise<ApiResponse<ClientOnboardingResponse>> {
        return this.makeAuthenticatedRequest<
            ApiResponse<ClientOnboardingResponse>
        >(API.UpdateClientOnboarding(), { onboarding }, { method: 'post' })
    }

    // Web Scraper
    async scrapeMedia(): Promise<{ jobId: string }> {
        const response = await this.makeAuthenticatedRequest<
            ApiResponse<{ jobId: string }>
        >(API.ScrapeMedia(), {}, { method: 'post' })

        if (response.isError) {
            throw new Error(response.message)
        }

        return response.result
    }
}

export const R = Requestor.getInstance()
